import { render, staticRenderFns } from "./UpdateNotePatient.vue?vue&type=template&id=4aa196d6&scoped=true&"
import script from "./UpdateNotePatient.vue?vue&type=script&lang=ts&"
export * from "./UpdateNotePatient.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateNotePatient.vue?vue&type=style&index=0&id=4aa196d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa196d6",
  null
  
)

export default component.exports